import React from 'react';

export const PatientDetails = (props) => {
  const patient = props.patient;
  const content = (patient === undefined) ? (<></>) :
  (
      <>
        <h4>Patient Details</h4>
        <div className='px-md-3'>
          <div className='row justify-content-start'>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='Patient LastName'
                className='form-control'
                readOnly
                value={patient.lastName || ""}
               />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='Patient FirstName'
                className='form-control'
                readOnly
                value={patient.firstName || ""}
               />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='Date of Birth'
                className='form-control'
                readOnly
                value={patient.dob || ""}
              />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='MRN'
                className='form-control'
                readOnly
                value={patient.mrn || ""}
              />
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='Address1'
                className='form-control'
                readOnly
                value={patient.address1 || ""}
              />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='Patient Address2'
                className='form-control'
                readOnly
                value={patient.address2 || ""}
              />
            </div>
            <div className='col-md-2 px-md-1'>
              <input type='text'
                placeholder='City'
                className='form-control'
                readOnly
                value={patient.city || ""}
              />
            </div>
            <div className='col-md-1 px-md-1'>
              <input type='text'
                placeholder='State'
                className='form-control'
                readOnly
                value={patient.state || ""}
              />
            </div>
            <div className='col-md-1 px-md-1'>
              <input type='text'
                placeholder='Zip'
                className='form-control'
                readOnly
                value={patient.zip || ""}
              />
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='School Name'
                className='form-control'
                readOnly
                value={patient.schoolName || ""}
              />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='SchoolGradeLevel'
                className='form-control'
                readOnly
                value={patient.schoolGradeLevel || ""}
              />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='GuardianFirstName'
                className='form-control'
                readOnly
                value={patient.guardianFirstName || ""}
              />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='GuardianLastName'
                className='form-control'
                readOnly
                value={patient.guardianLastName || ""}
              />
            </div>
          </div>
        </div>
      </>
    );

  return content;
}
